import { JoveLanguageEnum } from './common';
export var websiteAvailableLanguages = [{
  label: 'English',
  value: JoveLanguageEnum.EN,
  country: 'GB',
  englishName: 'English',
  chineseName: '英国'
}, {
  label: 'Dutch (Belgium)',
  value: JoveLanguageEnum.NL_BE,
  country: 'BE',
  englishName: 'Belgium',
  chineseName: '比利时'
}, {
  label: 'Bulgarian',
  value: JoveLanguageEnum.BG,
  country: 'BG',
  englishName: 'Bulgaria',
  chineseName: '保加利亚'
}, {
  label: 'Croatian',
  value: JoveLanguageEnum.HR,
  country: 'HR',
  englishName: 'Croatia',
  chineseName: '克罗地亚'
}, {
  label: 'Czech',
  value: JoveLanguageEnum.CZ,
  country: 'CZ',
  englishName: 'Czech Republic',
  chineseName: '捷克'
}, {
  label: 'Danish',
  value: JoveLanguageEnum.DK,
  country: 'DK',
  englishName: 'Denmark',
  chineseName: '丹麦'
}, {
  label: 'Estonian',
  value: JoveLanguageEnum.EE,
  country: 'EE',
  englishName: 'Estonia',
  chineseName: '爱沙尼亚'
}, {
  label: 'Finnish',
  value: JoveLanguageEnum.FI,
  country: 'FI',
  englishName: 'Finland',
  chineseName: '芬兰'
}, {
  label: 'French',
  value: JoveLanguageEnum.FR,
  country: 'FR',
  englishName: 'France',
  chineseName: '法国'
}, {
  label: 'German (Germany)',
  value: JoveLanguageEnum.DE,
  country: 'DE',
  englishName: 'Germany',
  chineseName: '德国'
}, {
  label: 'Greek',
  value: JoveLanguageEnum.GR,
  country: 'GR',
  englishName: 'Greece',
  chineseName: '希腊'
}, {
  label: 'Hungarian',
  value: JoveLanguageEnum.HU,
  country: 'HU',
  englishName: 'Hungary',
  chineseName: '匈牙利'
}, {
  label: 'Italian',
  value: JoveLanguageEnum.IT,
  country: 'IT',
  englishName: 'Italy',
  chineseName: '意大利'
}, {
  label: 'Latvian',
  value: JoveLanguageEnum.LV,
  country: 'LV',
  englishName: 'Latvia',
  chineseName: '拉脱维亚'
}, {
  label: 'Lithuanian',
  value: JoveLanguageEnum.LT,
  country: 'LT',
  englishName: 'Lithuania',
  chineseName: '立陶宛'
}, {
  label: 'French (Luxembourg)',
  value: JoveLanguageEnum.LU,
  country: 'LU',
  englishName: 'Luxembourg',
  chineseName: '卢森堡'
}, {
  label: 'Maltese',
  value: JoveLanguageEnum.MT,
  country: 'MT',
  englishName: 'Malta',
  chineseName: '马耳他'
}, {
  label: 'Dutch (Netherlands)',
  value: JoveLanguageEnum.NL_NL,
  country: 'NL',
  englishName: 'Netherlands',
  chineseName: '荷兰'
}, {
  label: 'Polish',
  value: JoveLanguageEnum.PL,
  country: 'PL',
  englishName: 'Poland',
  chineseName: '波兰'
}, {
  label: 'Portuguese',
  value: JoveLanguageEnum.PT,
  country: 'PT',
  englishName: 'Portugal',
  chineseName: '葡萄牙'
}, {
  label: 'Romanian',
  value: JoveLanguageEnum.RO,
  country: 'RO',
  englishName: 'Romania',
  chineseName: '罗马尼亚'
}, {
  label: 'Slovak',
  value: JoveLanguageEnum.SK,
  country: 'SK',
  englishName: 'Slovakia',
  chineseName: '斯洛伐克'
}, {
  label: 'Slovenian',
  value: JoveLanguageEnum.SL,
  country: 'SL',
  englishName: 'Slovenia',
  chineseName: '斯洛文尼亚'
}, {
  label: 'Spanish',
  value: JoveLanguageEnum.ES_ES,
  country: 'ES',
  englishName: 'Spain',
  chineseName: '西班牙'
}, {
  label: 'Swedish',
  value: JoveLanguageEnum.SE,
  country: 'SE',
  englishName: 'Sweden',
  chineseName: '瑞典'
}, {
  label: 'Norwegian',
  value: JoveLanguageEnum.NO,
  country: 'NO',
  englishName: 'Norway',
  chineseName: '挪威'
}];
export var getAllWebsiteAvailableLanguages = function getAllWebsiteAvailableLanguages() {
  var list = [].concat(websiteAvailableLanguages);
  [JoveLanguageEnum.EN, JoveLanguageEnum.HU, JoveLanguageEnum.HR].forEach(function (key) {
    var theIndex = list.findIndex(function (item) {
      return item.value === key;
    });

    if (key === JoveLanguageEnum.EN) {
      list.splice(theIndex + 1, 0, {
        label: 'German (Austria)',
        value: JoveLanguageEnum.AT,
        country: 'AT',
        englishName: 'Austria',
        chineseName: '奥地利'
      });
    } else if (key === JoveLanguageEnum.HR) {
      list.splice(theIndex + 1, 0, {
        label: 'Greek (Cyprus)',
        value: JoveLanguageEnum.CY,
        country: 'CY',
        englishName: 'Cyprus',
        chineseName: '塞浦路斯'
      });
    }
  });
  return list;
};
export var getWebsiteRouteLocaleToLanguageMap = function getWebsiteRouteLocaleToLanguageMap() {
  return {
    'nl-be': JoveLanguageEnum.NL_BE,
    bg: JoveLanguageEnum.BG,
    hr: JoveLanguageEnum.HR,
    cs: JoveLanguageEnum.CZ,
    cz: JoveLanguageEnum.CZ,
    dk: JoveLanguageEnum.DK,
    da: JoveLanguageEnum.DK,
    ee: JoveLanguageEnum.EE,
    et: JoveLanguageEnum.EE,
    fi: JoveLanguageEnum.FI,
    fr: JoveLanguageEnum.FR,
    de: JoveLanguageEnum.DE,
    el: JoveLanguageEnum.GR,
    gr: JoveLanguageEnum.GR,
    hu: JoveLanguageEnum.HU,
    it: JoveLanguageEnum.IT,
    lv: JoveLanguageEnum.LV,
    lt: JoveLanguageEnum.LT,
    lb: JoveLanguageEnum.LU,
    lu: JoveLanguageEnum.LU,
    mt: JoveLanguageEnum.MT,
    'nl-nl': JoveLanguageEnum.NL_NL,
    pl: JoveLanguageEnum.PL,
    'pt-pt': JoveLanguageEnum.PT,
    'pt-PT': JoveLanguageEnum.PT,
    pt: JoveLanguageEnum.PT,
    'ro-ro': JoveLanguageEnum.RO,
    'ro-RO': JoveLanguageEnum.RO,
    ro: JoveLanguageEnum.RO,
    sk: JoveLanguageEnum.SK,
    sl: JoveLanguageEnum.SL,
    es: JoveLanguageEnum.ES_ES,
    sv: JoveLanguageEnum.SE,
    se: JoveLanguageEnum.SE,
    no: JoveLanguageEnum.NO
  };
};